import { Body } from 'components/Typography';
import { twMerge } from 'tailwind-merge';
import { useConnection } from 'wagmi';
import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { useVaultOnChainData } from 'structure/pv2/dynavault/hooks/useVaultListBlockchain';
import { getVaultPositionDisplay } from 'structure/pv2/dynavault/utils/vaultPosition';

interface VaultPositionProps {
  className?: string;
  vault: DynaVault;
}

export const VaultPosition = (props: VaultPositionProps) => {
  const { className, vault } = props;

  const account = useConnection();

  const vaultOnChainData = useVaultOnChainData({
    vaultAddress: vault.address,
    chainId: vault.chainId,
    walletAddress: account.address as string,
  });

  const position = vaultOnChainData.data?.walletBalance || BigInt(0);

  // Convert vault price (in deposit token) to USD using oracle
  const vaultPriceInUsd = vaultOnChainData.data
    ? vaultOnChainData.data.vaultPrice
    : 0;

  const positionDisplay = getVaultPositionDisplay({
    position,
    decimals: vault.decimals,
    vaultPriceInUsd,
  });

  return (
    <div className={twMerge('flex flex-col items-end', className)}>
      {positionDisplay ? (
        <>
          <Body className='text-sm font-normal'>
            {positionDisplay.tokenAmount}
          </Body>
          <Body className='text-sm font-bold text-white-500'>
            ${positionDisplay.usdAmount}
          </Body>
        </>
      ) : (
        <Body className='text-sm font-normal'>-</Body>
      )}
    </div>
  );
};
